import React from 'react';
import { CheckCircle, X } from 'lucide-react';

interface PostRechargeModalProps {
  isOpen: boolean;
  creditedTokens: number;
  onClose: () => void;
}

export const PostRechargeModal: React.FC<PostRechargeModalProps> = ({
  isOpen,
  creditedTokens,
  onClose
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4"
      onClick={handleBackdropClick}
    >
      <div className="bg-gray-900 rounded-lg shadow-xl w-full max-w-md border border-gray-700">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-700 bg-gray-800">
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-green-400" />
            <h2 className="text-lg font-semibold text-white">Recarga Realizada!</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-700 rounded-full transition-colors text-gray-300 hover:text-white"
            title="Fechar"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 text-center">
          <div className="mb-4">
            <CheckCircle className="w-16 h-16 text-green-400 mx-auto mb-4" />
            <h3 className="text-xl font-bold text-white mb-2">
              Parabéns! 🎉
            </h3>
            <p className="text-gray-300 text-lg">
              Você recarregou <span className="font-bold text-green-400">{creditedTokens} tokens</span> com sucesso!
            </p>
          </div>
          
          <div className="bg-green-900/20 border border-green-700 rounded-lg p-4 mb-6">
            <p className="text-green-300 text-sm">
              Seus tokens já estão disponíveis em sua conta e podem ser utilizados imediatamente.
            </p>
          </div>

          <button
            onClick={onClose}
            className="w-full px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-colors"
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
  );
};

export default PostRechargeModal;